import React from 'react'

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;
const locationMapHeadImg = `${publicUrl}/location-map-head.png`;

interface ProposalLocationMapProps {
  proposedPropertyData: any;
}

export function ProposalLocationMap({ proposedPropertyData }: ProposalLocationMapProps) {
  return (
    <>
      {proposedPropertyData?.proposalDetails?.capturedLocationImage ? proposedPropertyData?.proposalDetails?.projectsOfProposals.length < 13 ? (
        <table className="table-outer-area page-break"
          style={{
            // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
            // backgroundImage: `url(${commonTableBg})`,
            backgroundImage: `url(${proposalTableShadow})`,
            backgroundPosition: "right",
            backgroundSize: "cover",
            marginTop: "15px",
            minHeight: "794px",
          }}
          width="100%"
          cellPadding="10"
          cellSpacing="0"
        >
          <tbody>
            <tr>
              <td align="right" colSpan={2}>
                <img
                  width={110}
                  src={logoIcon}
                  alt="property_image"
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ padding: "0" }}>
                <img
                  width={595}
                  style={{ width: "595px" }}
                  // src={require(`../../../assets/images/proposal/location-map-head.png`)}
                  src={locationMapHeadImg}
                  alt="property_image"
                />
              </td>
            </tr>
            <tr>
              <td valign="top" width="38%">
                <div
                  style={{
                    backgroundColor: "#F6F6F6",
                    padding: "13px 24px",
                    wordBreak: "break-all",
                  }}
                >
                  <ol
                    style={{
                      padding: "0",
                      listStyleType: "none",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {proposedPropertyData?.proposalDetails?.projectsOfProposals?.map(
                      (name: any, index: number) => {
                        return (
                          <li
                            style={{
                              color: "#00134F",
                              padding: "8px 0",
                            }}
                          >
                            <u>
                              {index + 1}
                              {". "}
                              {name}
                            </u>
                          </li>
                        )
                      }
                    )}
                  </ol>
                </div>
              </td>

              <td width="62%" valign='top' style={{ padding: "0" }}>
                <img
                  style={{
                    width: "100%",
                    marginTop: "-100px",
                    // height: "567px",
                    objectFit: "contain",
                  }}
                  src={
                    proposedPropertyData?.proposalDetails
                      ?.capturedLocationImage
                  }
                  alt="property_image"
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2} height={6}></td>
            </tr>
          </tbody>
        </table>
      ) :
        <>
          <table className="table-outer-area page-break"
            style={{
              // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
              // backgroundImage: `url(${commonTableBg})`,
              backgroundImage: `url(${proposalTableShadow})`,
              backgroundPosition: "right",
              backgroundSize: "cover",
              marginTop: "15px",
              minHeight: "794px",
            }}
            width="100%"
            cellPadding="10"
            cellSpacing="0"
          >
            <tbody>
              <tr>
                <td align="right" colSpan={2}>
                  <img
                    width={110}
                    src={logoIcon}
                    alt="property_image"
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{ padding: "0" }}>
                  <img
                    width={595}
                    style={{ width: "595px" }}
                    // src={require(`../../../assets/images/proposal/location-map-head.png`)}
                    src={locationMapHeadImg}
                    alt="property_image"
                  />
                </td>
              </tr>
              <tr>
                <td valign="top" width="33%">
                  <div
                    style={{
                      backgroundColor: "#F6F6F6",
                      padding: "13px 24px",
                      wordBreak: "break-all",
                    }}
                  >
                    <ol
                      style={{
                        padding: "0",
                        listStyleType: "none",
                        columnCount: 3,
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                    >
                      {proposedPropertyData?.proposalDetails?.projectsOfProposals?.map(
                        (name: any, index: number) => {
                          return (
                            <li
                              style={{
                                color: "#00134F",
                                padding: "8px 0",
                              }}
                            >
                              <u>
                                {index + 1}
                                {". "}
                                {name}
                              </u>
                            </li>
                          )
                        }
                      )}
                    </ol>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={2} height={6}></td>
              </tr>
            </tbody>
          </table>
          <table className="table-outer-area page-break"
            style={{
              // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
              // backgroundImage: `url(${commonTableBg})`,
              backgroundImage: `url(${proposalTableShadow})`,
              backgroundPosition: "right",
              backgroundSize: "cover",
              marginTop: "15px",
              minHeight: "794px",
            }}
            width="100%"
            cellPadding="10"
            cellSpacing="0"
          >
            <tbody>
              <tr>
                <td align="right" colSpan={2}>
                  <img
                    width={110}
                    src={logoIcon}
                    alt="property_image"
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{ padding: "0" }}>
                  <img
                    width={595}
                    style={{ width: "595px" }}
                    // src={require(`../../../assets/images/proposal/location-map-head.png`)}
                    src={locationMapHeadImg}
                    alt="property_image"
                  />
                </td>
              </tr>
              <tr>
                <td valign="top" colSpan={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <img
                    style={{
                      width: "100%",
                      height: "520px",
                      objectFit: "contain",
                    }}
                    src={
                      proposedPropertyData?.proposalDetails
                        ?.capturedLocationImage
                    }
                    alt="property_image"
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} height={6}></td>
              </tr>
            </tbody>
          </table>
        </>
        : null}
    </>
  );
}